import { render } from "./AboutPageFive.vue?vue&type=template&id=0c5775e4"
import script from "./AboutPageFive.vue?vue&type=script&lang=js"
export * from "./AboutPageFive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__